export const ObjectColumnBasedIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.75 15.925V4.075C8.75 2.95 8.27941 2.5 7.11029 2.5H4.13971C2.97059 2.5 2.5 2.95 2.5 4.075V15.925C2.5 17.05 2.97059 17.5 4.13971 17.5H7.11029C8.27941 17.5 8.75 17.05 8.75 15.925Z"
				stroke="#0047FF"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 15.925V4.075C17.5 2.95 17.0294 2.5 15.8603 2.5H12.8897C11.7206 2.5 11.25 2.95 11.25 4.075V15.925C11.25 17.05 11.7206 17.5 12.8897 17.5H15.8603C17.0294 17.5 17.5 17.05 17.5 15.925Z"
				stroke="#0047FF"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
